export default function (date, daysToAdd) {
  date.setDate(date.getDate() + Number(daysToAdd));

  return date;
}
